import React from 'react';

class NotFound extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {
        return (
            <div style={{background: '#0d68ac', width:'100%' }}>
                <div className="container">
                    <h3 className="header1-notFound text-center" style={{color: '#f5f5f5'}}>Sorry we can't find that page.</h3>
                </div>
            </div>
        )
    }
}

export default NotFound;
